import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import api from "../../../api/api";
import {
  formatCalendarDate,
  setCaseId,
  setClientId,
  standardFormatDate,
} from "../../../Utils/helper";
import { fetchCaseSummary, fetchHeaderSummary } from "../../../api/case";
import {
  fetchAllPages,
  fetchCurrentCase,
  setCaseSummary,
} from "../../../Redux/caseData/caseDataSlice";
import { setHeaderName } from "../../../Redux/header_name/action";
import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
import "./leastAccess.css";
import { setHeaderSummary } from "../../../Redux/header/headerDataSlice";
import BirthdayIcon from "../../../assets/images/birthdayicon.svg";
import DOIIcon from "../../../assets/images/incident.svg";
import UserChatBubble from "../../Forms/FirmUserBtn";

import avatarImage from "./../../../assets/images/avatar.svg";
function getStyles() {
  return {
    height: window.innerWidth > 2300 ? "50px" : "50px",
    paddingTop: window.innerWidth > 2300 ? "0px" : "0px",
    paddingBottom: window.innerWidth > 2300 ? "0px" : "0px",
    fontWeight: "600",
  };
}

const LeastAccess = ({ _chats }) => {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const [leastCases, setLeastCases] = useState([]);
  const [style, _setStyle] = useState({
    gap: window.innerWidth > 2300 ? "0px" : "0px",
    height: window.innerWidth > 2300 ? "50px" : "50px",
    flexDirection: window.innerWidth > 2300 ? "column" : "column",
    paddingTop: window.innerWidth > 2300 ? "5px" : "5px ",
    paddingBottom: window.innerWidth > 2300 ? "5px" : "5px",
    alignItems: window.innerWidth > 2300 ? "start" : "start",
  });
  const [divStyle, setDivStyle] = useState({});
  const [initialStyle, setInitialStyle] = useState(getStyles());
  const [className, setClassName] = useState(getClassName());
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  function getClassName() {
    return window.innerWidth > 2300 ? "paddingIssueinLeastAccess" : "";
  }

  useEffect(() => {
    const handleResize = () => {
      setClassName(getClassName());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setInitialStyle(getStyles());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setStyle({
  //       gap: window.innerWidth > 2300 ? "0px" : "0px",
  //       height: window.innerWidth > 2300 ? "50px" : "50px",
  //       flexDirection: window.innerWidth > 2300 ? "column" : "column",
  //       paddingTop: window.innerWidth > 2300 ? "5px" : "5px ",
  //       paddingBottom: window.innerWidth > 2300 ? "5px" : "5px",
  //       alignItems: window.innerWidth > 2300 ? "start" : "start",
  //     });
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchLeastCases = async () => {
    try {
      const response = await api.get(`${origin}/api/homepage/least-accessed-cases/`);

      if (response.status === 200) {
        const data = response.data;
        setLeastCases(data);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  useEffect(() => {
    fetchLeastCases();
  }, []);

  const isValidName = (str) => {
    return str && str.trim().length > 0 && /[a-zA-Z]/.test(str.trim());
  };

  const calculateRowHeight = () => (window.innerWidth > 2300 ? 50 : 50);

  const calculateRowsToDisplay = () => {
    const rowHeight = calculateRowHeight();
    const viewportHeight = window.innerHeight;
    return Math.floor(viewportHeight / rowHeight);
  };

  useEffect(() => {
    const handleResize = () => {
      const rowsToDisplay = calculateRowsToDisplay();
      const rowHeight = calculateRowHeight();
      setDivStyle({
        maxHeight: `${rowsToDisplay * rowHeight}px`,
        overflowY: "auto",
      });
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const changeCase = async (client_id, case_id) => {
    dispatch(setComponentLoadingEffect("medicalProviders", true));
    dispatch(setComponentLoadingEffect("detailBar", true));

    await api.get(`/api/switch_client/${client_id}/${case_id}/1/`);

    setClientId(client_id);
    setCaseId(case_id);
    dispatch(fetchCurrentCase(client_id, case_id));

    fetchHeaderSummary(client_id, case_id)
      .then((data) => {
        dispatch(setHeaderSummary(data));

        dispatch(setHeaderName("Case"));

        navigate(`/bp-case/${client_id}/${case_id}`, {
          replace: true,
        });
      })
      .catch(() => {});

    fetchCaseSummary(client_id, case_id)
      .then((data) => {
        dispatch(setCaseSummary(data));
        dispatch(fetchAllPages(case_id));

        dispatch(setHeaderName("Case"));

        navigate(`/bp-case/${client_id}/${case_id}`, {
          replace: true,
        });
      })
      .catch(() => {});

    // fetchHeaderSummary(client_id, case_id)
    //   .then((data) => {
    //     dispatch(setHeaderSummary(data));
    //     navigate(`/bp-case/${client_id}/${case_id}`, {
    //       replace: true,
    //     });
    //   })
    //   .catch(() => {});

    // fetchCaseSummary(client_id, case_id)
    //   .then((data) => {
    //     dispatch(setCaseSummary(data));
    //     dispatch(fetchAllPages(case_id));
    //     dispatch(setHeaderName("Case"));

    //     // navigate(`/bp-case/${client_id}/${case_id}`, {
    //     //   replace: true,
    //     // });
    //   })
    //   .catch(() => {});
  };

  // Set to track unique cases by the combination of client name and case type
  const renderedCases = new Set();

  const clientNameRefs = useRef([]);
  const [maxWidth, setMaxWidth] = useState("auto");

  useEffect(() => {
    if (clientNameRefs.current.length > 0) {
      let calculatedMaxWidth = 0;
      clientNameRefs.current.forEach((ref) => {
        if (ref && ref.clientWidth > calculatedMaxWidth) {
          calculatedMaxWidth = ref.clientWidth;
        }
      });
      setMaxWidth(`${calculatedMaxWidth}px`);
    }
  }, [leastCases]);

  const [placeholderCount, setPlaceholderCount] = useState(0);
  const tableRef1 = useRef(null);

  const calculatePlaceholderCount = () => {
    if (tableRef1.current) {
      const height = tableRef1.current.clientHeight;
      const count = Math.floor(height / 50);
      setPlaceholderCount(count);
    }
  };

  useEffect(() => {
    // Calculate on mount
    calculatePlaceholderCount();

    // Recalculate on window resize
    window.addEventListener("resize", calculatePlaceholderCount);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("resize", calculatePlaceholderCount);
    };
  }, []);

  return (
    <div className="column order-2 order-xxl-1 d-flex flex-column m-b-5 column1">
      <div className="bg-primary-5 height-25">
        <h4 className="client-contact-title text-center height-25 d-flex justify-content-center align-items-center h-100">
          Cases Least Accessed
        </h4>
      </div>
      {leastCases.length > 0 ? (
        <div
          className="table-responsive table--no-card position-relative border-0 has-tint-rows has-tint-h-35 flex-g-1"
          style={divStyle}
        >
          <table className="table table-striped position-relative z-index-1 position-relative bg-home-background-4-2">
            <thead className="d-none">
              <tr>
                <th
                  className=""
                  style={{
                    width: "25px",
                    minWidth: "25px",
                    maxWidth: "25px",
                  }}
                />
                <th className="td-autosize">Client</th>
                <th className="td-autosize">Dates</th>
                <th className="td-autosize">User</th>

                <th className="td-autosize">Last Accessed</th>
                <th
                  style={{
                    width: "5px",
                    minWidth: "5px",
                    maxWidth: "5px",
                  }}
                />
              </tr>
            </thead>
            <tbody>
              {leastCases.slice(0, calculateRowsToDisplay()).map((caseData, index) => {
                // eslint-disable-next-line no-unsafe-optional-chaining
                const { id, for_client, case_type, _incident_date } = caseData?.for_case;
                const { first_name, last_name, profile_pic_19p } = for_client || {};

                // Check if both first_name and last_name are valid (contains at least one letter after trimming)
                const isValidFirstName = isValidName(first_name);
                const isValidLastName = isValidName(last_name);

                // Create a unique identifier for the case using client name and case type
                const uniqueCaseIdentifier = `${first_name?.trim()} ${last_name?.trim()} - ${case_type?.name}`;

                // Only render the case if both first and last names are valid, and the case hasn't been rendered before
                if (
                  isValidFirstName &&
                  isValidLastName &&
                  !renderedCases.has(uniqueCaseIdentifier)
                ) {
                  // Mark this case as rendered by adding the unique identifier to the set
                  renderedCases.add(uniqueCaseIdentifier);

                  const renderClientName = `${first_name.trim()} ${last_name.trim()}`;
                  return (
                    <tr
                      key={id}
                      onClick={() => changeCase(for_client.id, id)}
                      style={{ textAlign: "start" }}
                    >
                      <td
                        // scope="row pb-0 pt-0 "
                        id={`${className}`}
                        style={{
                          width: "25px",
                          maxWidth: "25px",
                          minWidth: "25px",
                          textAlign: "center",
                          color: "var(--primary-25)",
                          ...initialStyle,
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className=" text-black d-flex justify-content-center pb-0 pt-0"
                        style={{
                          ...style,
                          // maxWidth: maxWidth,
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-center height-21">
                          <span className="ic ic-avatar ic-15 has-avatar-icon has-cover-img bg-white">
                            <img
                              src={profile_pic_19p ?? avatarImage}
                              style={{
                                background: "var(--primary-30)",
                              }}
                              className="theme-ring"
                            />
                          </span>
                          <span
                            className="m-l-5 client-type text-start d-block align-items-center"
                            ref={(el) => (clientNameRefs.current[index] = el)}
                            style={{ width: maxWidth, fontWeight: "600" }}
                          >
                            {renderClientName}
                          </span>
                        </div>
                        <div className=" d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={case_type?.casetype_icon} className="m-r-5 ic-15" />
                          {case_type?.name}
                        </div>
                      </td>
                      {/* <td /> */}
                      <td
                        style={{
                          minWidth: "100px",
                        }}
                        className=""
                      >
                        <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={BirthdayIcon} className="m-r-5 ic-15" />
                          {caseData?.for_case?.for_client.birthday}
                        </div>
                        <div className="d-flex height-21 align-items-center font-weight-600 nowrap">
                          <img src={DOIIcon} className="m-r-5 ic-15" />
                          {formatCalendarDate(caseData?.for_case?.incident_date)}
                        </div>
                      </td>
                      <td className="text-center">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            height: "50px",
                          }}
                        >
                          <UserChatBubble
                            userId={caseData?.last_accessed_by?.id}
                            first_name={caseData?.last_accessed_by?.first_name}
                            last_name={caseData?.last_accessed_by?.last_name}
                            profilePic={caseData?.last_accessed_by?.profile_pic ?? ""}
                            is_active={caseData?.last_accessed_by?.is_active}
                            width={19}
                            // height={25}
                            isActive={
                              userOnlineStatus?.[caseData?.last_accessed_by?.id]?.isOnline ?? false
                            }
                          />
                        </div>
                      </td>
                      {/* <td /> */}
                      <td className={"text-end"} style={initialStyle} id={`${className}`}>
                        {caseData?.last_accessed ? standardFormatDate(caseData?.last_accessed) : ""}
                      </td>
                      <td
                        style={{
                          width: "5px",
                          minWidth: "5px",
                          maxWidth: "5px",
                        }}
                      />
                    </tr>
                  );
                }

                // If the case is already rendered or has invalid names, skip rendering this row
                return null;
              })}
              {leastCases.length < calculateRowsToDisplay() &&
                Array.from({ length: calculateRowsToDisplay() - leastCases.length }, (_, index) => (
                  <tr className="" key={`fake-${index}`} style={style}>
                    <td className="" />
                    <td className=" text-black pb-0 pt-0 " />
                    <td className=" text-black pb-0 pt-0 " />
                    <td className=" text-black pb-0 pt-0 " />
                    <td className=" " />
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          className="table-responsive table--no-card position-relative border-0 flex-g-1"
          ref={tableRef1}
          style={divStyle}
        >
          <div className="home-tint-rows">
            {Array.from({ length: placeholderCount || 750 / 50 }).map((_, i) => (
              <div
                key={i}
                className=""
                style={{
                  height: "50px",
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeastAccess;
